// extracted by mini-css-extract-plugin
module.exports = {"understanding-check":"understanding-check__1RJpS","text":"text__2nugV","section-title":"section-title__2J0Qh","button-wrapper":"button-wrapper__8-Coi"};